import store from '@/store/index.js'
const router_domain_url = store.state.router_domain_url

// 异步请求处理
/**
 *
 * @param {路径} path
 * @param {组件路径} file
 * @param {别名，没有传null } name
 * @param {说明，没有就传{} } meta
 * @param {子级，没有子级可以不传} children
 */
function route(path, file, name, meta, children, redirect) {
  return {
    exact: true,
    path,
    name,
    meta,
    children,
    redirect,
    component: () => import(`@/views/customization/${router_domain_url}/pages/${file}`)
  }
}
const indexRouterlist = [
  route('/calculator', 'home/calculator', 'calculator', { title: '运费估算', ssr: true, pageWidth: true, keepAlive: true, requireAuth: false }),
  route('/order-pack-pay', 'Orders/OrderpackPay', 'OrderpackPay', { title: '订单打包', ssr: true, pageWidth: true, keepAlive: true, requireAuth: false }),
]
const publicRouterlist = [
  route('/sign-up', 'public/SignUp', 'signUp', { title: '注册', ssr: true, pageWidth: true, keepAlive: true, requireAuth: false }),
]
const personRouterlist = [
  route('/add-address', 'address/AddAddress', '', { title: '添加地址', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/bond-money', 'user/bondMoney', '', { title: '保证金', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/invitationCode', 'share/invitationCode', '', { title: '邀请码', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/money-list', 'share/moneyList', '', { title: '金额明细', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),
  route('/relevancy-user', 'share/relevancyUser', '', { title: '关联用户', ssr: true, pageWidth: true, keepAlive: false, requireAuth: true }),

]

export default {
  indexRouterlist: indexRouterlist,
  publicRouterlist: publicRouterlist,
  personRouterlist: personRouterlist,
}
